<form [formGroup]="form" (submit)="submit()">
  <div class="pref-section mb-10">
    <h2 class="font-bold mb-5" paint="plan-bg">What's New & Trending</h2>
    <h4 class="font-light mt-0 mb-10" paint="light">Get to know about new and expiring offers, news and services</h4>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_email" labelPosition="before">
        Email Notifications
      </mat-slide-toggle>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_sms" labelPosition="before">
        SMS Notifications
      </mat-slide-toggle>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_push" labelPosition="before">
        Push Notifications
      </mat-slide-toggle>
  </div>
  <mat-divider></mat-divider>
  <div class="pref-section">
    <h2 class="font-bold mb-5" paint="plan-bg">Your Exclusive Treats</h2>
    <h4 class="font-light mt-0 mb-10" paint="light">Enjoy birthday treats, as well as tailored offers, news and services</h4>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_email_remarketing" labelPosition="before">
        Email Notifications
      </mat-slide-toggle>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_sms_remarketing" labelPosition="before">
        SMS Notifications
      </mat-slide-toggle>
      <mat-slide-toggle class="pref-field package-toggle" paint="plan-bg" formControlName="optin_push_remarketing" labelPosition="before">
        Push Notifications
      </mat-slide-toggle>
  </div>
  <div class="custom-button f-col f-cross-center mb-20">
      <button mat-flat-button type="submit" class="package-button" paint="plan-bg" [disabled]="!form.dirty || this.service.loading()">
          Save Changes
      </button>
      <p class="font-light" paint="light">For more information, please review our <a routerLink="/privacy-policy">Privacy Policy</a></p>
  </div>
</form>